import mutateCreateAttractLoop from "./mutateCreateAttractLoop"
import mutateUpdateAttractLoop from "./mutateUpdateAttractLoop"
import mutateDeleteAttractLoop from "./mutateDeleteAttractLoop"
import withAttractLoopFormDetails from "./withAttractLoopFormDetails"
import withAttractLoops from "./withAttractLoops"

const queries = {
  mutateCreateAttractLoop,
  mutateUpdateAttractLoop,
  mutateDeleteAttractLoop,
  withAttractLoopFormDetails,
  withAttractLoops
}

export default queries



// WEBPACK FOOTER //
// ./src/AttractLoops/queries/index.js